export enum WidgetType {
  APPRAISALS = "APPRAISALS",
  BUTTONS = "BUTTONS",
  CONTAINER = "CONTAINER",
  PRIMARY = "PRIMARY",
  SIDEBAR = "SIDEBAR",
  MATRIX = "MATRIX",
  STRUCTURE = "STRUCTURE"
}
